import Vue from 'vue';
import VeeValidate from 'vee-validate';

Vue.use(VeeValidate, {
  fieldsBagName: 'vvFields' // Fixes an error which arises from mixing vee-validate and vue-json-csv
});
